import clsx from "clsx";
import {
  ComponentPropsWithoutRef,
  ContextType,
  createContext,
  ReactElement,
} from "react";

// eslint-disable-next-line react-refresh/only-export-components
export const TableContext = createContext<{
  bleed: boolean;
  dense: boolean;
  grid: boolean;
  striped: boolean;
}>({
  bleed: false,
  dense: false,
  grid: false,
  striped: false,
});

export const Table = ({
  allowOverflow = false,
  bleed = false,
  children,
  className,
  dense = false,
  grid = false,
  striped = false,
  ...props
}: {
  allowOverflow?: boolean;
  bleed?: boolean;
  dense?: boolean;
  grid?: boolean;
  striped?: boolean;
} & ComponentPropsWithoutRef<"div">): ReactElement => (
  <TableContext.Provider
    value={{ bleed, dense, grid, striped } as ContextType<typeof TableContext>}
  >
    <div className="flow-root">
      <div
        {...props}
        className={clsx(
          className,
          "-mx-[--gutter]",
          {
            "overflow-x-auto": !allowOverflow,
          },
          "whitespace-nowrap",
        )}
      >
        <div
          className={clsx(
            "inline-block min-w-full align-middle",
            !bleed && "sm:px-[--gutter]",
          )}
        >
          <table className="min-w-full text-left text-sm/6 text-zinc-950 dark:text-white">
            {children}
          </table>
        </div>
      </div>
    </div>
  </TableContext.Provider>
);
